import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '07ef257d-cac7-4645-85d1-0e8dfaee1e39',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '230d6d6b-010a-4eb9-a695-c9015c201471',
      type: 'Container',
      name: 'boardContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '206b8c0b-3953-407d-8384-f0389f72299c',
      type: 'Container',
      name: 'leftSpace',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '9938e5d8-2856-42d5-a87b-392ea6cbb777',
      type: 'Container',
      name: 'rightSpace',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: 'a7690fb5-67bc-4b4e-b341-bec62bef1446',
      type: 'Container',
      name: 'topSpace',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '43316511-72b9-4ecf-8c9e-c7dd3cfe9241',
      type: 'Sprite',
      name: 'shadow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 6,
        y: 5.602
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shadow',
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '4fa60ea0-851a-46db-b60d-40aa97bd21ed',
      type: 'Sprite',
      name: 'boardBackground',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'BUBBLE_FIELD_BACKGROUND',
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '3677c150-bdc7-4a21-8255-f096839b8277',
      type: 'Container',
      name: 'pointZonesContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: 'ce12abf4-c2c9-4504-b1ea-8c0a5faf484e',
      type: 'Container',
      name: 'bouncersContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '5fda4e81-cdc1-4b80-9819-d1b1164f36b0',
      type: 'Container',
      name: 'deathLineContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: 'b00b9d54-6dc6-407b-885d-1405fbde1815',
      type: 'Container',
      name: 'bubblesGridContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: 'c35c6a1c-e7de-4d21-9bb7-50dad30e26fe',
      type: 'Container',
      name: 'fxAboveGrid',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '1d90b5a5-3463-48d4-a811-dafdb55ece54',
      type: 'Container',
      name: 'bubblesShootedContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '3df02bca-f932-4334-a633-52db1edf57f3',
      type: 'Container',
      name: 'bubblesPopOutContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '8c8f4cf9-6b9e-4def-9040-bb53305de131',
      type: 'Container',
      name: 'shooterPointerContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '89434f65-223f-435d-a68b-a5fd36bb1e20',
      type: 'Container',
      name: 'shooterContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '72fd5616-2575-4e6d-b942-ac4cdf475ab0',
      type: 'Sprite',
      name: 'leaderBoardButton',
      className: '',
      x: -300,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'YELLOW_BUTTON_BG',
      parent: 'a7690fb5-67bc-4b4e-b341-bec62bef1446'
    },
    {
      id: '33bda4ea-fe07-41d4-908b-1f5ae9a265f8',
      type: 'Sprite',
      name: 'soundButton',
      className: '',
      x: 300,
      y: 55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'YELLOW_BUTTON_BG',
      parent: 'a7690fb5-67bc-4b4e-b341-bec62bef1446'
    },
    {
      id: '6881e9f4-7818-4503-ae18-d5132a3f0467',
      type: 'Sprite',
      name: 'musicButton',
      className: '',
      x: 300,
      y: 160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'YELLOW_BUTTON_BG',
      parent: 'a7690fb5-67bc-4b4e-b341-bec62bef1446'
    },
    {
      id: 'a820e462-effb-45af-b570-50580687aa63',
      type: 'Sprite',
      name: 'leaderboardLabel',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'TROPHY',
      parent: '72fd5616-2575-4e6d-b942-ac4cdf475ab0'
    },
    {
      id: '361cbcc3-341a-49c6-a6c6-454b7a5cdf1a',
      type: 'Sprite',
      name: 'soundLabelOn',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'SOUND_ON',
      parent: '33bda4ea-fe07-41d4-908b-1f5ae9a265f8'
    },
    {
      id: 'c1877f47-5353-4469-8243-fbef2c3071d2',
      type: 'Sprite',
      name: 'soundLabelOff',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'SOUND_OFF',
      parent: '33bda4ea-fe07-41d4-908b-1f5ae9a265f8'
    },
    {
      id: '2fdb5882-d0cd-4322-a552-53cba506d8f9',
      type: 'Sprite',
      name: 'musicLabelOn',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'MUSIC_ON',
      parent: '6881e9f4-7818-4503-ae18-d5132a3f0467'
    },
    {
      id: 'b69d2003-4d48-4cd6-a7b2-124133c34a5e',
      type: 'Sprite',
      name: 'musicLabelOff',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'MUSIC_OFF',
      parent: '6881e9f4-7818-4503-ae18-d5132a3f0467'
    }
  ],
  x: 50,
  y: 0,
  width: 730,
  height: 1085,
  handleResize: true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  boardContainer: boolean;
  leftSpace: boolean;
  rightSpace: boolean;
  topSpace: boolean;
  shadow: boolean;
  boardBackground: boolean;
  pointZonesContainer: boolean;
  bouncersContainer: boolean;
  deathLineContainer: boolean;
  bubblesGridContainer: boolean;
  fxAboveGrid: boolean;
  bubblesShootedContainer: boolean;
  bubblesPopOutContainer: boolean;
  shooterPointerContainer: boolean;
  shooterContainer: boolean;
  leaderBoardButton: boolean;
  soundButton: boolean;
  musicButton: boolean;
  leaderboardLabel: boolean;
  soundLabelOn: boolean;
  soundLabelOff: boolean;
  musicLabelOn: boolean;
  musicLabelOff: boolean;

}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly boardContainer: PIXI.Container;
  public readonly leftSpace: PIXI.Container;
  public readonly rightSpace: PIXI.Container;
  public readonly topSpace: PIXI.Container;
  public readonly shadow: PIXI.Sprite;
  public readonly boardBackground: PIXI.Sprite;
  public readonly pointZonesContainer: PIXI.Container;
  public readonly bouncersContainer: PIXI.Container;
  public readonly deathLineContainer: PIXI.Container;
  public readonly bubblesGridContainer: PIXI.Container;
  public readonly fxAboveGrid: PIXI.Container;
  public readonly bubblesShootedContainer: PIXI.Container;
  public readonly bubblesPopOutContainer: PIXI.Container;
  public readonly shooterPointerContainer: PIXI.Container;
  public readonly shooterContainer: PIXI.Container;
  public readonly leaderBoardButton: PIXI.Sprite;
  public readonly soundButton: PIXI.Sprite;
  public readonly musicButton: PIXI.Sprite;
  public readonly leaderboardLabel: PIXI.Sprite;
  public readonly soundLabelOn: PIXI.Sprite;
  public readonly soundLabelOff: PIXI.Sprite;
  public readonly musicLabelOn: PIXI.Sprite;
  public readonly musicLabelOff: PIXI.Sprite;


  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
